import React from 'react';
import PropTypes from 'prop-types';
import {
  Box,
  Grid,
  Switch,
  Typography,
} from '@mui/material';
import TelusSettingTable from './TelusSettingTable';
import { useApiClient } from '../../../../context/ApiClientContext';

export default function TelusSettingPane(props) {
  const {
    entity,
    telusSettings,
    onSave,
    setValues,
    refreshParent,
    setSuccessMessage,
    setErrorMessage,
  } = props;
  const apiClient = useApiClient();

  const handleSave = (setting, value) => {
    onSave(setting.name, setting.category, value);
  };

  return (
    <Box sx={{ margin: '16px' }}>
      <Grid
        container
        justifyContent="space-between"
      >
        <Grid
          item
          alignItems="column"
        >
          <Typography
            variant="body1"
          >
            Telus Enabled
            <Switch
              checked={telusSettings?.enabled?.value === 'true'}
              onChange={(event) => {
                handleSave(
                  telusSettings.enabled,
                  event.target.checked.toString(),
                );
              }}
              name="Telus enabled"
            />
          </Typography>
        </Grid>
      </Grid>
      <TelusSettingTable
        entity={entity}
        telusSettings={telusSettings}
        apiClient={apiClient}
        handleSave={handleSave}
        setValues={setValues}
        refreshParent={refreshParent}
        setSuccessMessage={setSuccessMessage}
        setErrorMessage={setErrorMessage}
      />
    </Box>
  );
}

// First, define a reusable setting shape
const settingShape = PropTypes.shape({
  name: PropTypes.string.isRequired,
  category: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
});

TelusSettingPane.propTypes = {
  entity: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
    settings: PropTypes.arrayOf(PropTypes.shape({
      name: PropTypes.string,
      category: PropTypes.string,
      value: PropTypes.string,
    })),
  }).isRequired,
  onSave: PropTypes.func.isRequired,
  telusSettings: PropTypes.shape({
    enabled: settingShape,
    authCredentials: settingShape,
    providerIds: settingShape,
    intakePlanId: settingShape,
    appointmentCutoffDateTime: settingShape,
    operatingHours: settingShape,
    timezone: settingShape,
    smsHoursBeforeAppointment: settingShape,
  }).isRequired,
  setValues: PropTypes.func.isRequired,
  refreshParent: PropTypes.func.isRequired,
  setErrorMessage: PropTypes.func.isRequired,
  setSuccessMessage: PropTypes.func.isRequired,
};
